import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

/*
 * Тоже самое, что и useEffect, только этот хук не вызывается во время mount'a компонента.
 * Логика работы аналогична методу жизненного цикла willReceiveProps (react v16)
 */
export const useComponentWillReceiveProps = (
  callback: EffectCallback,
  deps?: DependencyList,
): void => {
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    callback();
  }, deps);
};
